














import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import SelectOption from '../models/SelectOption';

@Component
export default class VMultiSwitcher extends Vue {
  @Prop() readonly value!: string|number;
  @Prop() readonly items!: Readonly<Array<SelectOption>>;
  @Prop() readonly size? : string;

  @Watch('value')
  onValueChange(value: string|number) {
    this.selected = value;
  }

  protected selected: string|number = this.value;

  get btnGroupClass() {
    return {
      'btn-group-sm': this.size === 'sm'
    }
  }

  activate(item: SelectOption) {
    if (item.disabled) {
      return;
    }

    this.selected = item.id;
    this.$emit('input', this.selected);
  }
}
